var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.load)?_c('div',{class:{'app-phone': _vm.screenWidth <= 992},attrs:{"id":"app"}},[_c('router-view'),(_vm.screenWidth > 992)?_c('home-footer'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }